import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "footer" }

interface Props {
  title?: string;
  content?: string;
  normallyOpen?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpansionWrapper',
  props: {
    title: {},
    content: {},
    normallyOpen: { type: Boolean, default: false }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", {
    class: "expansion-panel",
    open: __props.normallyOpen
  }, [
    _createElementVNode("summary", null, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("strong", null, _toDisplayString(__props.title), 1)
      ])
    ]),
    _createElementVNode("article", null, [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createElementVNode("div", { innerHTML: __props.content }, null, 8, _hoisted_2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ], 8, _hoisted_1))
}
}

})